import { v4 } from 'uuid';
import { z } from 'zod';

const stringifiedId = z.preprocess(val => typeof val === "number" ? String(val) : val, z.string());

/**
 * Specification of the response format for form based steps.
 */

/**
 * Specification of the response format for form based steps.
 */

const formTaskSchema = z.object({
  type: z.literal("form"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  alignment: z.enum(["left", "top", "right", "bottom"]).nullish().default("left"),
  guideFieldWidth: z.union([z.literal("auto"), z.preprocess(val => Number(val), z.number())]).nullish().default(null),
  guide: z.string(),
  inputs: z.array(z.object({
    id: stringifiedId.default("undefined"),
    type: z.enum(["input", "text"]),
    text: z.string(),
    predefinedAnswer: z.string().nullish().default(null),
    showFormatted: z.boolean().nullish().default(false)
  }))
});

/**
 * @legacy Specification of the response format for editor based steps.
 */

const transformEditorTaskToFormTaskSchema = z.object({
  type: z.literal("editor"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  alignment: z.enum(["left", "top", "right", "bottom"]).nullish().default("left"),
  guideFieldWidth: z.union([z.literal("auto"), z.preprocess(val => Number(val), z.number())]).nullish().default(null),
  guide: z.string(),
  editorTitle: z.string().nullish().default(null),
  contents: z.string().nullish().default(null)
}).transform(editorTask => ({
  type: "form",
  id: editorTask.id,
  title: editorTask.title ?? null,
  alignment: editorTask.alignment,
  guideFieldWidth: editorTask.guideFieldWidth,
  guide: editorTask.guide,
  inputs: [{
    type: "text",
    text: editorTask.editorTitle ?? "",
    id: "input",
    maxLengthType: "characters",
    showFormatted: true,
    predefinedAnswer: editorTask.contents
  }]
}));

/**
 * @legacy Specification of the response format for guide based steps.
 */

const transformGuideTaskToFormTaskSchema = z.object({
  type: z.literal("info"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  guide: z.string()
}).transform(editorTask => ({
  type: "form",
  id: editorTask.id,
  title: editorTask.title ?? null,
  alignment: "left",
  guideFieldWidth: "auto",
  guide: editorTask.guide,
  inputs: []
}));
const iGuideDataSchema = z.object({
  description: z.string(),
  tasks: z.array(z.union([formTaskSchema, transformEditorTaskToFormTaskSchema, transformGuideTaskToFormTaskSchema])),
  settings: z.object({
    enableBackground: z.boolean().default(false),
    formatting: z.array(z.string()).nullish().default(null),
    languages: z.array(z.string().nullish().transform(lang => lang != undefined ? transformLang(lang) : null)).nullish().default(null),
    latexParser: z.string().nullish().default(null)
  })
});
function transformLang(lang) {
  switch (lang) {
    case "fr":
    case "French":
      return "French";
    case "de":
    case "German":
      return "German";
    case "en":
    case "English":
      return "English";
    case "es":
    case "Spanish":
      return "Spanish";
    case "da":
    default:
      return "Danish";
  }
}

export { iGuideDataSchema };
//# sourceMappingURL=i-guide.component-data.js.map
